
    // TEXT input for "ProductOverview"
    const input = {
    // Product REVIEWS
    reviews: {
        href: 'https://www.google.com/',
        average: 4,
        totalCount: 117
    },

    // Product DESCRIPTIONS
    product: {
        // General Information about the product
        name: 'Navi Jeans',
        price: '$50',
        to: 'men/clothing/zara1/Zara1',
        id: 'product-men-zara1',
        
        // Product Breadcrumbs
        breadcrumbs: [
            { id: 1, name: 'Men', to: '/men/clothing' },
            // { id: 2, name: 'Clothing', to:'/men/clothing'},
            // { id: 3, name: 'Bottoms', to: '/men/clothing/bottoms' },
        ],

        //Product Images
        images: [
            {
            src: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/men/2/product_men_2-1.jpg',
            alt: 'image 1',
            },
            {
            src: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/men/2/product_men_2-2.jpg',
            alt: 'image 2',
            },
            {
            src: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/men/2/product_men_2-3.jpg',
            alt: 'image 3',
            },
            {
            src: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/men/2/product_men_2-4.jpg',
            alt: 'image 4',
            },
        ],

        // Product Colors
        colors: [
            { name: 'White', class: 'bg-white', selectedClass: 'ring-gray-400' },
            { name: 'Gray', class: 'bg-gray-200', selectedClass: 'ring-gray-400' },
            { name: 'Black', class: 'bg-gray-900', selectedClass: 'ring-gray-900' },
        ],

        // Product Sizing
        sizes: [
            { name: 'XS', inStock: true },
            { name: 'XS+', inStock: true },
            { name: 'S', inStock: true },
            { name: 'S+', inStock: true },
            { name: 'M', inStock: true },
            { name: 'M+', inStock: true },
            { name: 'L', inStock: true },
            { name: 'L+', inStock: true },
            { name: 'XL', inStock: true },
            { name: 'XL+', inStock: true },
            { name: '2XL', inStock: true },
            { name: '2XL+', inStock: true },
            { name: '3XL', inStock: true },
        ],

        // Product Introduction
        description:
            "Navi Jeans. Crafted from premium, stretch-infused denim, these jeans offer a flattering fit that moves with you all day long. Whether you're dressing them up or down, Navi Jeans are designed for everyday versatility and lasting wear.",
        
        // Product Bulletpoints
        highlights: [
            'Machine wash max',
            'Do not use bleach / whitener',
            'Do not dry clean or tumble dry',
            '100% Cotton'
        ],
        
        // Product Additional Information
        details:
            'To lengthen the life of your denim garments, always wash them inside out in low temperatures. This way we help preserve the colors and structure of the fabric and reduce energy consumption.',
    },

    // Personalized Recommendation per Product
    recommendation: [
        {
            id: 1,
            name: 'Basic Tee',
            category: "Men's T-Shirts",
            href: '/men/clothing/tops/nike1',
            imageSrc: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/men/1/product_men_1-1.jpg',
            imageAlt: "Front of men's Basic Tee in black.",
            price: '$35',
            color: 'Black',
        },
        // {
        //     id: 2,
        //     name: 'Basic Tee',
        //     category: "Men's T-Shirts",
        //     href: '/men/clothing/bottoms/zara1',
        //     imageSrc: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/men/2/product_men_2-1.jpg',
        //     imageAlt: "Front of men's Basic Tee in black.",
        //     price: '$35',
        //     color: 'Black',
        // },
        {
            id: 3,
            name: 'Basic Tee',
            category: "Men's T-Shirts",
            href: '/men/clothing/tops/nike3',
            imageSrc: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/men/3/product_men_3-1.jpg',
            imageAlt: "Front of men's Basic Tee in black.",
            price: '$35',
            color: 'Black',
        },
        {
            id: 4,
            name: 'Basic Tee',
            category: "Men's T-Shirts",
            href: '/men/clothing/tops/nike4',
            imageSrc: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/men/4/product_men_4-1.jpg',
            imageAlt: "Front of men's Basic Tee in black.",
            price: '$35',
            color: 'Black',
        },
        // More products...
    ]

    }

    export default input
    
